export class SecongLevelMenuConstants {
    public static TRAINING = 'Training';
    public static TOOLS = 'Tools';
    public static RECOGNITION = 'Recognition';
    public static FLP360 = 'FLP360';
    public static REPORTS = 'Reports';
    public static REPORTS_URL = '/reports/myorder';


}